import { Component, OnInit, Input } from '@angular/core';
import { DbRecord } from '../db-record';
import { RTagGroupService } from '../r-tag-group.service';

@Component({
  selector: 'app-r-tag-group',
  templateUrl: './r-tag-group.component.html',
  styleUrls: ['./r-tag-group.component.css']
})
export class RTagGroupComponent implements OnInit {
  @Input() group: [Object, Object[]];
  @Input() dbRecord: DbRecord;


  constructor(private rtgs: RTagGroupService) { }

  ngOnInit() {

  }

  get isSelectedMain() {
    return this.rtgs.hasRTag(this.dbRecord, this.group[0]['id']);
  }

  isSelectedSubtag(st) {
    return this.rtgs.hasRTag(this.dbRecord, st['id']);
  }

  get mainTag() {
    return this.group[0];
  }

  get subTags() {
    return this.group[1];
  }

  switch(rtid?: string) {
    let deleteLs;
    if (!rtid) {
      rtid = this.group[0]['id'];
      deleteLs = this.group[1].map(x => x['id']);
    }

    this.rtgs.saveGroup(this.dbRecord, rtid, deleteLs);
  }



}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/r-tag-group/r-tag-group.component.ts